export const makeDashboard = (index) => {
  const dashboard = {
    associationId: null,
    baseReportName: null,
    index,
    metricGroupBy: null,
    metricType: null,
    reportPath: null,
    routeName: null,
    subId: null,
  }

  return dashboard
}

export const copyDashboard = (dashboardOriginal, index) => {
  const dashboard = {
    associationId: dashboardOriginal.associationId,
    baseReportName: dashboardOriginal.baseReportName,
    index: typeof index === 'number' ? index : dashboardOriginal.index,
    metricGroupBy: dashboardOriginal.metricGroupBy || null,
    metricType: dashboardOriginal.metricType || null,
    reportPath: dashboardOriginal.reportPath,
    routeName: dashboardOriginal.routeName,
    subId: dashboardOriginal.subId,
  }

  return dashboard
}

export const copyDashboards = (dashboards) => dashboards.reduce((newDashboardsArray, dashboard, dashboardIndex) => {
  const dashboardCopy = copyDashboard(dashboard, dashboardIndex)

  newDashboardsArray.push(dashboardCopy)

  return newDashboardsArray
}, [])

export const addDashboard = (dashboardToAdd, dashboardsArray) => {
  const dashboards = copyDashboards(dashboardsArray)
  const newDashboard = copyDashboard(dashboardToAdd, dashboards.length)

  dashboards.push(newDashboard)

  return dashboards
}

export const editDashboard = (indexToEdit, dashboardEdits, dashboardsArray) => {
  const dashboards = copyDashboards(dashboardsArray)
  const newDashboard = copyDashboard(dashboardEdits, indexToEdit)

  dashboards.splice(indexToEdit, 1, newDashboard)

  return dashboards
}

export const deleteDashboard = (indexToDelete, dashboardsArray) => {
  const dashboards = copyDashboards(dashboardsArray)

  dashboards.splice(indexToDelete, 1)

  return dashboards.map((dashboard, index) => {
    dashboard.index = index
    return dashboard
  })
}
